<div>
  <app-titlebar #titlebar >
  </app-titlebar>
</div>

<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="條件設定">
    <mat-toolbar class="h-9">
      <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doQuery()">
        <mat-icon fontIcon="search"></mat-icon>查詢
      </button>
      <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doGetPreFilter()">
        <mat-icon fontIcon="search"></mat-icon>取前次
      </button>
    </mat-toolbar>
    <td class="w-1/2">
      <mat-label>選項</mat-label>
      <app-jkcombobox label="股票主機" [(value)]="filterOpt.stockHost" [items]="hostList">
      </app-jkcombobox>
      <app-jkcombobox label="查詢種類" [(value)]="filterOpt.kind" [items]="filterOpt.kindList">

      </app-jkcombobox>
      <app-jkcombobox label="股票代號" [(value)]="filterOpt.stockNo" [items]="stkma001List" [showClearButton]="false">

      </app-jkcombobox>
      <app-jkcombobox label="排序方式" [(value)]="filterOpt.order" [items]="orderList">
      </app-jkcombobox>
      <app-jkcheckbox label="有設追蹤價格的" [(value)]="filterOpt.stktmHaveSet"></app-jkcheckbox>
    </td>

    <!-- <app-jkcombobox label="查詢種類" [(value)]="pageOpt.kind" [items]="kindList">

    </app-jkcombobox>
    <app-jkcombobox label="股票代號" [(value)]="pageOpt.stockNo" [items]="stkma001List" [showClearButton]="false">

    </app-jkcombobox>
    <app-jkcombobox label="排序方式" [(value)]="pageOpt.order" [items]="orderList">
    </app-jkcombobox> -->
</mat-tab>
  <mat-tab #myTabDetail label="詳細資料">
    <app-jkgridwin #jkgridwin
      (afterGridReady)="afterGridReady($event)"></app-jkgridwin>
  </mat-tab>
</mat-tab-group>

